import { SHARED_CAP_TABLE_MIN_PASSWORD_LENGTH } from '../../../hooks/shared-cap-table/shared-cap-table.types';

type PasswordStateProps = {
  hasStoredPassword: boolean;
  /** `null` — protection off; `''` — toggle on, nothing typed; otherwise the new password. */
  password: null | string;
};

type PasswordState = {
  /** Whitespace alone clears the length minimum but protects nothing. */
  isBlank: boolean;
  /** Submitting would publish an unprotected link while the toggle reads "on". */
  isIncomplete: boolean;
  /** Empty field stands for the password already stored on the link. */
  keepsStoredPassword: boolean;
};

export const resolveSharePasswordState = ({
  hasStoredPassword,
  password,
}: PasswordStateProps): PasswordState => {
  const keepsStoredPassword = hasStoredPassword && password === '';
  const isBlank = !keepsStoredPassword && !!password && password.trim().length === 0;

  return {
    isBlank,
    isIncomplete:
      isBlank ||
      (!keepsStoredPassword &&
        password !== null &&
        password.length < SHARED_CAP_TABLE_MIN_PASSWORD_LENGTH),
    keepsStoredPassword,
  };
};
